import { DeleteIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Center,
  FormControl,
  FormLabel,
  HStack,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableCaption,
  Image,
  Flex,
  TableContainer,
} from "@chakra-ui/react";
import React, { Component } from "react";
import Header from "../../../components/Header";
import {
  DeleteContato,
  InserirHistoricoTMK,
  ListaFunilDeVenda,
  ListaMotivoPerda,
  ListaParceiroCadastro,
  runVerificaAutenticacao,
  SalvarDadosContato,
  SalvarDadosParceiro,
} from "../../../services/api";
import { cpfMask } from "../../../services/mask";
import { ModalEditarParceiros } from "./ModalEditarParceiros";
import { ModalVisualizarParceiros } from "./ModalVisualizarParceiros";
import {
  ContainerParceiros,
  InputParceiros,
  ParceirosContainerText,
} from "./styles";
import { ModalAddParceiros } from "./ModalAddParceiros";

const loading = "../../images/loading-verde.gif";
class Parceiros extends Component {
  constructor(props) {
    super(props);
    this.state = {
      view_loading: false,
      dados: [],
      codigo_parceiro: null,
      nome_parceiro: null,
      cpf_cnpj_parceiro: null,
      email_parceiro: null,
      razao_social_parceiro: null,
      codigo_usuario: JSON.parse(localStorage.getItem("authentication"))
        .codigo_usuario,
    };
  }

  componentDidMount() {
    runVerificaAutenticacao();

    this.getFunilVendas();
    this.getMotivoPerda();

    //se a tecla enter for pressionada, chama a função de buscar
    document.addEventListener("keydown", (event) => {
      if (event.key === "Enter") {
        this.getListaClientes();
      }
    });
  }

  ifNull(a, b) {
    if (a === null || a === "" || a === undefined) {
      return b;
    } else {
      return a;
    }
  }

  getListaClientes = async () => {
    this.setState({ dados: [] });
    if (
      this.ifNull(this.state.codigo_parceiro, "") === "" &&
      this.ifNull(this.state.nome_parceiro, "") === "" &&
      this.ifNull(this.state.email_parceiro, "") === "" &&
      this.ifNull(this.state.cpf_cnpj_parceiro, "") === "" &&
      this.ifNull(this.state.razao_social_parceiro, "") === ""
    ) {
      alert("É obrigatório preencher ao menos um campo!");
    } else {
      console.log(this.state.razao_social_parceiro);
      try {
        await this.setState({ view_loading: true });
        const params = {
          nome_parceiro: this.state.nome_parceiro,
          codigo_parceiro: this.state.codigo_parceiro,
          cpf_cnpj_parceiro: this.state.cpf_cnpj_parceiro,
          email_parceiro: this.state.email_parceiro,
          razao_social: this.state.razao_social_parceiro,
        };

        const response = await ListaParceiroCadastro.post("", params);
        let data = response.data;

        console.log(response);

        console.log(params);

        console.log(data);
        this.setState({
          dados: data,
        });
        await this.setState({ view_loading: false });
      } catch (error) {
        console.log(Object.keys(error), error.message);
      }
    }
  };

  getFunilVendas = async () => {
    try {
      const response = await ListaFunilDeVenda.post("", {});
      var data = response.data;

      this.setState({ funilVendas: data });
    } catch (error) {
      console.log(Object.keys(error), error.message);
    }
  };

  getMotivoPerda = async () => {
    try {
      const response = await ListaMotivoPerda.get();
      var data = response.data;

      this.setState({ motivo_perda: data });
    } catch (error) {
      console.log(Object.keys(error), error.message);
    }
  };

  onChange = (e, value, type = "input") => {
    if (type === "mask") {
      this.setState({
        [value]: cpfMask(e.target.value),
      });

      console.log(this.state.cpf_cnpj_parceiro);
    } else {
      this.setState({ [value]: e.target.value });

      console.log(this.state.razao_social_parceiro);
    }
  };

  changeValueField = async (e, data, type, value) => {
    if (type == "input") {
      var option = e.target.value;
    } else if (type == "select") {
      var option = e.target.options[e.target.options.selectedIndex].value;
    } else if (type == "input_bool") {
      if (e.target.value == "S") {
        var option = "N";
      } else {
        var option = "S";
      }
    }

    this.state.dados.map((item) => {
      if (item.codigo_parceiro == data.codigo_parceiro) {
        item[value] = option;
      }
    });

    this.setState({ update: true });
  };

  saveDataClient = async (data) => {
    try {
      var response = await SalvarDadosParceiro.post("", data);
      var data = response.data;

      if (data.result) {
        alert(data.message);
        const response2 = await ListaParceiroCadastro.post("", {
          nome_parceiro: this.state.nome_parceiro,
          codigo_parceiro: this.state.codigo_parceiro,
          cpf_cnpj_parceiro: this.state.cpf_cnpj_parceiro,
          email_parceiro: this.state.email_parceiro,
          razao_social_parceiro: this.state.razao_social_parceiro,
        });
        let data2 = response2.data;
        this.setState({ dados: data2 });
      } else {
        alert("Erro ao atualizar parceiro.");
      }
    } catch (error) {
      console.log(Object.keys(error), error.message);
    }
  };

  insertNewClient = async (data, onClose) => {
    try {
      // ClienteEspecial
      // CpfCnpj
      // NomeParceiro
      // RazaoSocial
      // InscricaoEstadual
      // ClassificacaoICMS
      // TipoPessoa
      // Contrato
      // CEP
      // NumeroEndereco
      // Complento
      // Email
      var response = await SalvarDadosParceiro.post("", {
        cep_parceiro: data.CEP,
        cliente_especial: data.ClienteEspecial,
        complemento_parceiro: data.Complemento,
        cpf_cnpj_parceiro: data.CpfCnpj,
        email_parceiro: data.Email,
        id_classificacao_parceiro:
          data.ClassificacaoICMS == null ? "X" : data.ClassificacaoICMS,
        id_tipo_pessoa: data.TipoPessoa == null ? "F" : data.TipoPessoa,
        inscricao_estadual_parceiro: data.InscricaoEstadual,
        nome_parceiro: data.NomeParceiro,
        numero_contrato_parceiro: data.Contrato,
        numero_endereco_parceiro: data.NumeroEndereco,
        razao_social_parceiro: data.RazaoSocial,
      });
      var data = response.data;

      if (data.result) {
        alert(data.message);
        onClose();
        // this.getListaClientes();
      } else {
        alert("Erro ao atualizar parceiro.");
      }
    } catch (error) {
      console.log(Object.keys(error), error.message);
    }
  };

  insertNewContact = async (data) => {
    try {
      var response = await SalvarDadosContato.post("", data);
      var data = response.data;

      if (data.result) {
        alert(data.message);
        const response2 = await ListaParceiroCadastro.post("", {
          nome_parceiro: this.state.nome_parceiro,
          codigo_parceiro: this.state.codigo_parceiro,
          cpf_cnpj_parceiro: this.state.cpf_cnpj_parceiro,
          email_parceiro: this.state.email_parceiro,
          razao_social_parceiro: this.state.razao_social_parceiro,
        });
        let data2 = response2.data;
        this.setState({ dados: data2 });
      } else {
        alert("Erro ao atualizar parceiro.");
      }
    } catch (error) {
      console.log(Object.keys(error), error.message);
    }
  };

  enviarTMK = async (data) => {
    try {
      const response = await InserirHistoricoTMK.post("", {
        data_retorno: data.dataRetorno,
        codigo_usuario: this.state.codigo_usuario,
        funil_de_venda: data.funilVendas,
        descricao: data.observacao,
        codigo_motivo: data.motivoPerdida,
      });

      var data = response.data;

      if (data.result) {
        alert(data.message);
        const response2 = await ListaParceiroCadastro.post("", {
          nome_parceiro: this.state.nome_parceiro + "nome",
          codigo_parceiro: this.state.codigo_parceiro,
          cpf_cnpj_parceiro: this.state.cpf_cnpj_parceiro,
          email_parceiro: this.state.email_parceiro,
          razao_social_parceiro: this.state.razao_social_parceiro,
        });
        let data2 = response2.data;
        this.setState({ dados: data2 });
      } else {
        alert("Erro ao inserir telemarketing.");
      }
    } catch (error) {
      console.log(Object.keys(error), error.message);
    }
  };

  deleteContact = async (data) => {
    try {
      var response = await DeleteContato.post("", data);
      var data = response.data;

      if (data.result) {
        alert(data.message);
        const response2 = await ListaParceiroCadastro.post("", {
          nome_parceiro: this.state.nome_parceiro,
          codigo_parceiro: this.state.codigo_parceiro,
          cpf_cnpj_parceiro: this.state.cpf_cnpj_parceiro,
          email_parceiro: this.state.email_parceiro,
          razao_social_parceiro: this.state.razao_social_parceiro,
        });
        let data2 = response2.data;
        this.setState({ dados: data2 });
      } else {
        alert("Erro ao atualizar parceiro.");
      }
    } catch (error) {
      console.log(Object.keys(error), error.message);
    }
  };

  render() {
    return (
      <>
        <ContainerParceiros>
          <ParceirosContainerText>
            <h1>
              CADASTRAR <strong>CLIENTE</strong>
            </h1>
          </ParceirosContainerText>
          <Center paddingInline={"1rem"}>
            <Box
              fontFamily="Akrobat"
              bgColor="white"
              boxShadow="2px 2px 5px 2px gray"
              mt="1rem"
              w="100%"
              h="150px"
            >
              <Center>
                <HStack w="95%" mt="2rem" spacing={8}>
                  <FormControl variant="floating">
                    <InputParceiros
                      focusBorderColor="#03a9f4"
                      size="md"
                      type="text"
                      placeholder=" "
                      onChange={(e) => this.onChange(e, "codigo_parceiro")}
                    />
                    <FormLabel color="gray.400">Cód. do Cliente</FormLabel>
                  </FormControl>
                  {/* <FormControl variant="floating">
                    <InputParceiros
                      focusBorderColor="#03a9f4"
                      size="md"
                      type="text"
                      placeholder=" "
                      onChange={(e) => this.onChange(e, "nome_parceiro")}
                    />
                    <FormLabel color="gray.400">Nome do Cliente</FormLabel>
                  </FormControl> */}
                  <FormControl variant="floating">
                    <InputParceiros
                      focusBorderColor="#03a9f4"
                      value={this.state.cpf_cnpj_parceiro}
                      size="md"
                      type="text"
                      placeholder=" "
                      onChange={(e) =>
                        this.onChange(e, "cpf_cnpj_parceiro", "mask")
                      }
                    />
                    <FormLabel color="gray.400">CPF/CNPJ Cliente</FormLabel>
                  </FormControl>
                  <FormControl variant="floating">
                    <InputParceiros
                      focusBorderColor="#03a9f4"
                      size="md"
                      type="text"
                      placeholder=" "
                      onChange={(e) => this.onChange(e, "email_parceiro")}
                    />
                    <FormLabel color="gray.400">E-mail do Cliente</FormLabel>
                  </FormControl>
                  <FormControl variant="floating">
                    <InputParceiros
                      focusBorderColor="#03a9f4"
                      size="md"
                      type="text"
                      placeholder=" "
                      onChange={(e) => {
                        this.onChange(e, "razao_social_parceiro");
                        this.onChange(e, "nome_parceiro");
                      }}
                    />
                    <FormLabel color="gray.400">Razão Social/Nome</FormLabel>
                  </FormControl>
                </HStack>
              </Center>
              <Center mt="1rem">
                <Flex>
                  <ModalAddParceiros insertNewClient={this.insertNewClient} />
                  <Button
                    ml="0.5rem"
                    variant="outline"
                    color="#03a9f4"
                    borderColor="#03a9f4"
                    _hover={{ bgColor: "#d6eef7" }}
                    _active={{ bgColor: "#d6eef7" }}
                    boxShadow="none !important"
                    onClick={() => this.getListaClientes()}
                  >
                    FILTRAR
                  </Button>
                </Flex>
              </Center>
            </Box>
          </Center>
          <Center mt="2rem" width="100%" paddingInline="1rem">
            <TableContainer w="100%" style={{ overflowX: "auto" }}>
              <Table
                fontFamily="Akrobat"
                w="95%"
                variant="striped"
                colorScheme="blackAlpha"
                margin="0 auto"
              >
                <TableCaption>Tabela de Clientes</TableCaption>
                <Thead>
                  <Tr>
                    <Th color="#03a9f4" w="50px">
                      Vendedor
                    </Th>
                    <Th color="#03a9f4" w="10px">
                      Editar
                    </Th>
                    <Th color="#03a9f4" w="10px">
                      Visualizar
                    </Th>
                    <Th color="#03a9f4">Excluir</Th>
                    <Th color="#03a9f4">Nome</Th>
                    <Th color="#03a9f4">Código</Th>
                    <Th color="#03a9f4">CNPJ/CPF</Th>
                    <Th color="#03a9f4">E-mail</Th>
                    <Th color="#03a9f4">Razão Social</Th>
                    <Th color="#03a9f4">Cep</Th>
                  </Tr>
                </Thead>
                {this.state.view_loading ? (
                  <Box
                    w="100%"
                    h="50%%"
                    position="absolute"
                    zIndex="99999"
                    bgColor="#F4F5F5"
                  >
                    <Center mt="6rem" mb="4rem">
                      <Image alt="loading" src={loading} />
                    </Center>
                  </Box>
                ) : (
                  <Tbody>
                    {this.state.dados.map((dado) => {
                      return (
                        <Tr>
                          <Td>
                            {dado.nome_vendedor === "<SEM VENDEDOR>"
                              ? "Sem vendedor"
                              : dado.nome_vendedor}
                          </Td>

                          <Td>
                            <ModalEditarParceiros
                              data={dado}
                              funilVendas={this.state.funilVendas}
                              motivoPerda={this.state.motivo_perda}
                              getListaClientes={this.getListaClientes}
                              changeValueField={this.changeValueField}
                              saveDataClient={this.saveDataClient}
                              insertNewContact={this.insertNewContact}
                              deleteContact={this.deleteContact}
                              enviarTMK={this.enviarTMK}
                              visualizar={false}
                            />
                          </Td>
                          <Td>
                            <ModalEditarParceiros
                              data={dado}
                              funilVendas={this.state.funilVendas}
                              motivoPerda={this.state.motivo_perda}
                              getListaClientes={() => {}}
                              changeValueField={() => {}}
                              saveDataClient={() => {}}
                              insertNewContact={() => {}}
                              deleteContact={() => {}}
                              enviarTMK={() => {}}
                              visualizar={true}
                            />
                          </Td>
                          <Td>
                            <Button
                              variant="link"
                              leftIcon={<DeleteIcon color="#03a9f4" />}
                              color="#03a9f4"
                            >
                              excluir
                            </Button>
                          </Td>
                          <Td>{dado.nome_parceiro}</Td>
                          <Td>{dado.codigo_parceiro}</Td>
                          <Td>{dado.cpf_cnpj_parceiro}</Td>
                          <Td>{dado.email_parceiro}</Td>
                          <Td>{dado.razao_social_parceiro}</Td>
                          <Td>{dado.cep_parceiro}</Td>
                        </Tr>
                      );
                    })}
                  </Tbody>
                )}
              </Table>
            </TableContainer>
          </Center>
        </ContainerParceiros>
      </>
    );
  }
}
export default Parceiros;
